import { useCallback, useEffect, useMemo, useState } from 'react';
import { buildListingPreview } from '../utils/buildListingPreview';
import type { BusinessListingPreview, PartnerBusiness, WizardPreviewDraft } from '../types';

export function useWizardListingPreview(
  business: PartnerBusiness | null,
  step: number,
): {
  preview: BusinessListingPreview;
  updatePreview: (patch: WizardPreviewDraft) => void;
  resetPreview: () => void;
} {
  const [liveDraft, setLiveDraft] = useState<WizardPreviewDraft>({});

  useEffect(() => {
    setLiveDraft({});
  }, [step]);

  const preview = useMemo(
    () => buildListingPreview(business, liveDraft),
    [business, liveDraft],
  );

  const updatePreview = useCallback((patch: WizardPreviewDraft) => {
    setLiveDraft((prev) => ({ ...prev, ...patch }));
  }, []);

  const resetPreview = useCallback(() => setLiveDraft({}), []);

  return { preview, updatePreview, resetPreview };
}
